<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
  <g stroke="none" stroke-width="1" fill-rule="evenodd">
      <rect fill="none" fill-opacity="0" x="0" y="0" width="24" height="24"/>
      <rect x="4" y="4" width="16" height="16" rx="2"/>
  </g>
</svg>